import {OctTable, OctTableCollapse} from "@oceantech/oceantech-ui";
import React, {Dispatch, SetStateAction, useEffect, useState} from "react";
import '../DanhSachKeHoach.scss';
import {Button} from "react-bootstrap";
import {SELECTION_MODE} from "../../../../utils/Constant";

interface Props {
  isView?: boolean;
  shouldNotShowActionTop?: boolean;
  title?: string;
  columns: any[];
  dsItems: any[];
  type?: any;
  setInitialValuesFormThemVT: Dispatch<SetStateAction<any>>,
  setOpenDialog?: Dispatch<SetStateAction<any>>,
}

const TableDangKyDaoTao = (props: Props) => {
  const {type, dsItems, isView, title, columns,  setOpenDialog = () => {}, shouldNotShowActionTop = false} = props;

  return (
    <div className="spaces mt-12 border-table custom-table">
      <div className="d-flex spaces pr-8 mt-6 bg-white justify-content-between align-items-center mb-6">
        <div className=" bg-white flex align-items-center mr-13 spaces">
          <div className="title spaces ml-10">
            {title}
          </div>
        </div>
        {!shouldNotShowActionTop && <div className="flex">
          <Button className="btn-fill ml-10 spaces min-w-90px btn btn-primary"
                  onClick={() => setOpenDialog(type)}>
            <i className="bi bi-plus-lg text-pri fs-3"></i>
            Thêm
          </Button>
          {/*<Button className="btn-fill ml-10 spaces min-w-90px btn btn-primary">*/}
          {/*  <i className="bi bi-trash3-fill text-danger fs-3"></i>*/}
          {/*  Xóa*/}
          {/*</Button>*/}
        </div>}
      </div>
      <OctTable
        id="table-tt-nhap-thuoc"
        className={`spaces custom-header-table ${isView ? 'table-view-tt-ke-hoach' : 'table-tt-ke-hoach'}`}
        columns={columns}
        data={dsItems}
        noToolbar
        clearToolbar
        noPagination
        fixedColumnsCount={-1}
      />


    </div>
  );
};

export default TableDangKyDaoTao;
